<template>
  <div class="modal-center">
    <data-upload :params="params_d" v-if="show_upload"></data-upload>
    <data-review :params="params_d" v-if="!show_upload"></data-review>
  </div>
</template>
<script>
import DataReview from '@/pages/customer/p_center/dataReview.vue'
import DataUpload from '@/pages/customer/p_center/dataUpload.vue'
export default {
  name: 'DataParent',
  componentName: 'DataParent',
  components: {
    DataReview,
    DataUpload
  },
  data () {
    return {
      show_upload: this.is_upload,
      params_d: this.params
    }
  },
  props: {
    is_upload: {
      type: Boolean,
      default: true
    },
    params: Object
  },
  created () {
    //切换审核/上传 资料页面的事件
    this.$on('cut.data', this.cut)
  },
  methods: {
    cut (params) {
      this.params_d = params
      this.show_upload = !this.show_upload
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/customer/p_center/dataParent.vue